import { Fragment, h } from '@stencil/core';
import type { ObservableMap } from '@stencil/store';

import type { MatchStoreState } from '../../../../../services/interfaces';
import { calendarDateFormat, dateFormat } from '../../../../../services/libraries';
import { getMatchWording, isUpcomingMatch, isVerticalLayout, setCssVariant } from '../../helpers';

type Props = {
  state: ObservableMap<MatchStoreState>['state'];
};

const MatchDate = ({ state }: Props) => {
  const size = state.size;
  const cssVariant = setCssVariant(size);
  const isVertical = isVerticalLayout(size);

  const match = state.matchData;
  if (!match) return null;

  const calendarFormat = state.dateCalendarFormat;
  if (!isVertical) {
    const withDayWeek = 'ddd D MMM';
    calendarFormat.nextWeek = withDayWeek;
    calendarFormat.lastWeek = withDayWeek;
    calendarFormat.sameElse = withDayWeek;
  }

  const customTimeZone = state.customTimeZone;

  const matchDateTime = match.kickOffTime?.dateTime;
  const matchDate = matchDateTime ?? match.kickOffTime?.date;
  const kickOffDateLocale = matchDate ? calendarDateFormat(matchDate, state.dateCalendarFormat, customTimeZone) : '';

  const kickOffTimeLocale = matchDateTime ? dateFormat(matchDateTime, 'HH:mm', customTimeZone) : getMatchWording('tbc');

  const upcomingMatch = isUpcomingMatch(match.status);

  const hideDate = state.hideDate;
  const showDateElement = !!matchDate && !hideDate;

  return (
    <Fragment>
      {showDateElement && (
        <span class={{ 'pk-match__datetime--date': true, ...cssVariant }} part="match-date">
          {kickOffDateLocale}
          {isVertical && ','}
        </span>
      )}
      {upcomingMatch && (
        <span
          class={{
            'pk-match__datetime--time': true,
            'with-date': showDateElement,
            ...cssVariant,
          }}
          part="match-time"
        >
          {kickOffTimeLocale}
        </span>
      )}
    </Fragment>
  );
};

export { MatchDate };
